import { AUGMENTT_POSTURE_STATES } from '@augmentt-dev/ui-components/src/reports/SecurityPosture/constants'

export const createMissingTemplateCheck = (checkId) => ({
  checkId,
  status: AUGMENTT_POSTURE_STATES.NOT_MEASURED,
  category: '',
})

export const buildTemplateChecksFromPosture = (templateCheckIds, postureChecks) => {
  const checksById = new Map(postureChecks.map((check) => [check.checkId, check]))

  return templateCheckIds.map((checkId) => checksById.get(checkId) ?? createMissingTemplateCheck(checkId))
}
